<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>schedule</md-icon>
          </div>
          <h4 class="title">
            Exporteren van onkosten vergoedingen per chauffeur
          </h4>
        </md-card-header>
        <md-card-content>
          <ValidationObserver ref="form">
            <form @submit.prevent="validate" autocomplete="off">
              <ValidationProvider
                name="startDate"
                :rules="{
                  required: true,
                  regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field
                  class="md-datepicker"
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Start datum</label>
                  <md-datepicker
                    v-model="startDate"
                    name="startDate"
                    id="startDate"
                    :md-model-type="String"
                    md-immediately
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="stopDate"
                :rules="{
                  required: true,
                  regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field
                  class="md-datepicker"
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Stop datum</label>
                  <md-datepicker
                    v-model="stopDate"
                    :md-model-type="String"
                    md-immediately
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <md-field>
                <div class="md-layout-item md-inline-checkboxes">
                  <md-checkbox v-model="perKm"
                    >Vergoeding per kilometer
                  </md-checkbox>
                </div>
              </md-field>

              <ValidationProvider
                v-if="perKm"
                name="perKmAmount"
                :rules="{
                  required: true,
                  regex: /^([0-9]{1,2}).([0-9]{2})$/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Vergoeding per kilometer</label>
                  <md-input
                    v-model="perKmAmount"
                    type="number"
                    step="0.01"
                    min="0"
                    max="10"
                    @blur="perKmAmountFormat"
                  >
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <md-field>
                <div class="md-layout-item md-inline-checkboxes">
                  <md-checkbox v-model="perShift"
                    >Vergoeding per dienst
                  </md-checkbox>
                </div>
              </md-field>

              <ValidationProvider
                v-if="perShift"
                name="perKmAmount"
                :rules="{
                  required: true,
                  regex: /^([0-9]{1,2}).([0-9]{2})$/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Vergoeding per kilometer</label>
                  <md-input
                    v-model="perShiftAmount"
                    type="number"
                    step="0.01"
                    min="0"
                    max="10"
                    @blur="perShiftAmountFormat"
                  >
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="exportType"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Export type</label>
                  <md-select
                    v-model="exportType"
                    name="exportType"
                    id="exportType"
                    required
                  >
                    <md-option
                      v-for="(exportType, index) in exportTypes"
                      :value="exportType.value"
                      :key="index"
                      >{{ exportType.label }}
                    </md-option>
                  </md-select>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                v-if="exportType === 'pain'"
                name="executionDate"
                :rules="{
                  required: true,
                  regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field
                  class="md-datepicker"
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Uitvoer datum betaling</label>
                  <md-datepicker
                    v-model="executionDate"
                    name="executionDate"
                    id="executionDate"
                    :md-model-type="String"
                    md-immediately
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </form>
          </ValidationObserver>
        </md-card-content>

        <md-card-actions>
          <md-button
            :disabled="exportButtonDisabled"
            native-type="button"
            @click.native.prevent="validate"
            class="md-success md-button-full-size md-sm"
          >
            Download export
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    selectedExportTypeLabel: function() {
      for (let i in this.exportTypes) {
        if (this.exportTypes[i]["value"] === this.exportType) {
          return this.exportTypes[i]["label"];
        }
      }

      return "";
    },
    exportButtonDisabled: function() {
      if ((!this.perKm && !this.perShift) || this.disabled) {
        return true;
      }

      return false;
    }
  },
  data() {
    return {
      startDate: null,
      stopDate: null,
      perKm: false,
      perKmAmount: 0.25,
      perShift: false,
      perShiftAmount: 0.75,
      exportType: "xlsx",
      exportTypes: [
        { label: "Excel XLSX", value: "xlsx" },
        { label: "Sepa Pain 001.001.03", value: "pain" }
      ],
      executionDate: null,
      disabled: false
    };
  },
  methods: {
    init() {
      this.startDate = this.formatDate(this.getDate(-30));
      this.stopDate = this.formatDate(this.getDate(0));
      this.executionDate = this.formatDate(this.getDate(+1));

      this.$material.locale.dateFormat = "dd-MM-yyyy";
      this.$material.locale.firstDayOfAWeek = 1;
      this.$material.locale.days = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag"
      ];
      this.$material.locale.shortDays = [
        "Zon",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vri",
        "Zat"
      ];
      this.$material.locale.shorterDays = ["Z", "M", "D", "W", "D", "V", "Z"];
      this.$material.locale.months = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ];
      this.$material.locale.shortMonths = [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ];
      this.$material.locale.shorterMonths = [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
      ];
    },
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }

        this.downloadExport();
      });
    },
    downloadExport() {
      this.notifyVue(
        "Export " + this.selectedExportTypeLabel + " download gestart",
        "check",
        "success",
        5000
      );
      this.disabled = true;

      let uri =
        "drivers/traveling-expenses/export/" +
        this.exportType +
        "/" +
        this.formatDateBack(this.startDate) +
        "/" +
        this.formatDateBack(this.stopDate) +
        "/" +
        (this.perKm ? this.perKmAmount : 0) +
        "/" +
        (this.perShift ? this.perShiftAmount : 0);

      if (this.exportType === "xlsx") {
        uri += "/export.xlsx";
      } else if (this.exportType === "pain") {
        uri += "/" + this.formatDateBack(this.executionDate);
      }

      this.$http
        .get(this.$apiBaseUrl + uri, {
          responseType: "blob"
        })
        .then(
          response => {
            this.disabled = false;
            const filename = response.headers.map["content-disposition"][0]
              .split(";")[1]
              .split("filename")[1]
              .split("=")[1]
              .trim()
              .replaceAll('"', "");
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const fURL = document.createElement("a");

            fURL.href = fileURL;
            fURL.setAttribute("download", filename);
            document.body.appendChild(fURL);
            fURL.click();
            document.body.removeChild(fURL);
          },
          response => {
            this.disabled = false;
            this.notifyVue(
              "Fout geconstateerd tijdens exporteren van de onkosten:<br/>" +
                response.body,
              "report_problem",
              "danger",
              0
            );
          }
        );
    },
    getDate(dayOffset = 0) {
      let day = new Date();
      if (dayOffset !== 0) {
        day.setDate(day.getDate() + dayOffset);
      }
      let dd = String(day.getDate()).padStart(2, "0");
      let mm = String(day.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = day.getFullYear();

      return yyyy + "-" + mm + "-" + dd;
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    perKmAmountFormat() {
      this.perKmAmount = parseFloat(this.perKmAmount).toFixed(2);
    },
    perShiftAmountFormat() {
      this.perShiftAmount = parseFloat(this.perShiftAmount).toFixed(2);
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.md-card-content > span > form > span > .md-field.md-datepicker {
  padding-top: 15px;

  &:after {
    bottom: 20px;
  }
}
</style>
